/* eslint-disable import/prefer-default-export */

const INPUT_FONT_SIZE = '1rem';

export const createInputBaseStyles = theme => ({
  '& > .MuiInputBase-input': {
    fontSize: INPUT_FONT_SIZE,
    color: theme.palette.primary.main,
  },
});

export const createBaseStyles = theme => ({
  visibility: props => (props.hidden ? 'hidden' : 'inherit'),
  position: 'relative',
  paddingBottom: theme.spacing(2.5),
  // NOTE: This is not something to repeat - just trying to get around a mistake I made earlier.
  '&.no-helper-text-padding': {
    paddingBottom: 0,
  },
  '& > .MuiFormHelperText-root > span': {
    fontSize: theme.typography.h6.fontSize,
  },
  '& > .MuiFormLabel-root': {
    fontSize: INPUT_FONT_SIZE,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.primaryGray,
  },
  '& > .MuiInputBase-root': {
    ...createInputBaseStyles(theme),
  },
  '& > .MuiInputBase-root > .MuiOutlinedInput-notchedOutline > legend': {
    fontSize: '1em',
  },
});
